<div class="container mt-5 mb-5">
	<div class="left-container">
		<img src="../../../../assets/images/login-img.svg" />
	</div>
	<div class="right-container">
		<h1 class="title">Kyqu</h1>
		<p class="paragraph mb-5">
			Ju lutemi shkruani kredencialet për të vazhduar.
		</p>

		<form [formGroup]="loginForm" class="login-form">
			<div class="password-container">
				<label class="label-input mb-2" for="email">
					Email addresa
				</label>
				<input
					class="input mb-3"
					nbInput
					type="text"
					formControlName="email"
					placeholder="example@mail.com"
					tabindex="1"
				/>

				<span *ngIf="submitted && emailError" class="error-message"
					>Ju lutem shkruani email addresen!</span
				>
			</div>

			<div class="password-container">
				<label class="label-input mb-2" for="password">
					Fjalëkalimi
				</label>
				<input
					class="input mb-3"
					nbInput
					type="password"
					formControlName="password"
					placeholder="Fjalëkalimi"
					[type]="showPasswordArgs ? 'text' : 'password'"
					tabindex="2"
				/>
				<nb-icon
					class="eye-icon"
					[icon]="showPasswordArgs ? 'eye' : 'eye-off'"
					(click)="showPassword()"
				></nb-icon>

				<span *ngIf="submitted && passwordError" class="error-message"
					>Ju lutem shkruani fjalëkalimin!</span
				>
			</div>

			<p class="short-paragraph mb-2" routerLink="/forgot-password">
				Keni harruar fjalëkalimin?
			</p>

			<button
				nbButton
				type="submit"
				class="blue-button"
				[disabled]="requesting"
				[nbSpinner]="requesting"
				nbSpinnerStatus="control"
				(click)="emitForm()"
				tabindex="3"
			>
				Kyqu
			</button>

			<h6 class="server-error">
				{{ serverError }}
			</h6>
		</form>
	</div>
</div>
